import { ItemTypeDefinition } from '../index';
import { t } from '@lingui/macro';
import Portrait from '@material-ui/icons/Portrait';

import slugs from '../../displaySlugs';
import gql from 'graphql-tag';

import Views from 'workspaces/views';

const itemType = 'trainingRecord';

const listViewColumns = [
  {
    field: 'customIdentifier',
    headerName: 'ID',
    type: 'id',
  },
  {
    field: 'currentVersion.title',
    headerName: 'Title',
    type: 'regular_text',
  },
  {
    field: 'currentVersion.currentStatusName',
    headerName: 'Status',
    type: 'status',
  },
  {
    field: 'currentVersion.createdAt',
    headerName: 'Initiation Date',
    type: 'date',
  },
  {
    field: 'currentVersion.dueDate',
    headerName: 'Due Date',
    type: 'date',
  },
];

const listViewQuery = gql`
  query trainingRecordsQuery {
    trainingRecords {
      id
      itemType {
        id
        displaySlug
        userCreatable
      }
      customIdentifier
      createdAt
      currentVersion {
        id
        createdAt
        title
        versionIdentifier
        currentStatusName
        dueDate
      }
    }
  }
`;

export default {
  displaySlug: slugs[itemType],
  itemType,
  label: t`Training Record`,
  categoryLabel: t`Training Records`,
  icon: Portrait,
  listViewQuery,
  listViewColumns,
  listWorkspace: [Views.Table, Views.LinksGraph],
  recordWorkspace: [Views.Builder, Views.Effective],
  titleEditable: false,
} as ItemTypeDefinition;
